import { NgModule } from '@angular/core';
import { AssetGroupHeaderComponent } from '@app/features/main/banner/asset-group-header/asset-group-header.component';
import { AssetHeaderComponent } from '@app/features/main/banner/asset-header/asset-header.component';
import { BannerComponent } from '@app/features/main/banner/banner.component';
import { ClientHeaderComponent } from '@app/features/main/banner/client-header/client-header.component';
import { DefaultHeaderComponent } from '@app/features/main/banner/default-header/default-header.component';
import { EquipmentHeaderComponent } from '@app/features/main/banner/equipment-header/equipment-header.component';
import { HeaderTemplateDirective } from '@app/features/main/banner/header-template.directive';
import { InvestmentHeaderComponent } from '@app/features/main/banner/investment-header/investment-header.component';
import { MeetingHeaderComponent } from '@app/features/main/banner/meeting-header/meeting-header.component';
import {
  OrganizationClassesHeaderComponent
} from '@app/features/main/banner/organization-classes-header/organization-classes-header.component';
import { ProjectHeaderComponent } from '@app/features/main/banner/project-header/project-header.component';
import {
  UserBiReportsHeaderComponent
} from '@app/features/main/banner/user-bi-reports-header/user-bi-reports-header.component';
import { ClientsListService } from '@app/features/main/views/management/client/clients-inventory/clients-list.service';
import { WorkflowButtonsComponent } from '@app/shared/components/workflow-buttons/workflow-buttons.component';
import { SharedModule } from '@app/shared/shared.module';
import { WorkHeaderComponent } from './work-header/work-header.component';
import {
  RestrictedIconButtonComponent
} from '@app/shared/components/restricted-icon-button/restricted-icon-button.component';

const components = [
  ClientHeaderComponent,
  AssetGroupHeaderComponent,
  AssetHeaderComponent,
  EquipmentHeaderComponent,
  WorkHeaderComponent,
  ProjectHeaderComponent,
  InvestmentHeaderComponent,
  MeetingHeaderComponent,
  UserBiReportsHeaderComponent,
  OrganizationClassesHeaderComponent,
  DefaultHeaderComponent,
  BannerComponent
];

@NgModule({
  imports: [
    SharedModule,
    RestrictedIconButtonComponent,
    WorkflowButtonsComponent
  ],
  declarations: [
    ...components,
    HeaderTemplateDirective
  ],
  providers: [
    ClientsListService
  ],
  exports: [
    ...components
  ]
})
export class BannerRoutingModule {
}
